/**
 * Use this enum to define the possibilities of render function of drawer selected value
 */
export enum DRAWER_VALUES {
  ORDERS = 'ORDERS',
  ADRESSES = 'ADRESSES',
  ACCOUNT_INFORMATION = 'ACCOUNT_INFORMATION',
}
